import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RedirectPageComponent } from './redirect.page';

const routes: Routes = [
  {
    component: RedirectPageComponent,
    path: ':status'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class RedirectPageRoutingModule {}
